import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import CookieConsent from './components/CookieConsent';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Portfolio from './pages/Portfolio';
import Contact from './pages/Contact';
import DigitalCard from './pages/DigitalCard';

// Layout with Navbar/Footer for main pages
const MainLayout = ({ children }) => (
  <div className="flex flex-col min-h-screen">
    <Navbar />
    <main className="flex-1">{children}</main>
    <Footer />
    <WhatsAppButton />
    <CookieConsent />
  </div>
);

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          {/* Digital Card - standalone without navbar/footer */}
          <Route path="/card/mihai-radulescu" element={<DigitalCard />} />
          
          {/* Main pages with layout */}
          <Route path="/" element={<MainLayout><Home /></MainLayout>} />
          <Route path="/despre" element={<MainLayout><About /></MainLayout>} />
          <Route path="/servicii" element={<MainLayout><Services /></MainLayout>} />
          <Route path="/portofoliu" element={<MainLayout><Portfolio /></MainLayout>} />
          <Route path="/contact" element={<MainLayout><Contact /></MainLayout>} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
